import { render, staticRenderFns } from "./SafeForWorkOption.vue?vue&type=template&id=4cdf3138&scoped=true&"
import script from "./SafeForWorkOption.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkOption.vue?vue&type=script&lang=ts&"
import style0 from "./SafeForWorkOption.vue?vue&type=style&index=0&id=4cdf3138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf3138",
  null
  
)

export default component.exports